import React, { useState, useEffect } from "react";
import "../css/AddNewQuiz.css";
import { useHistory, Redirect, useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../User/navbar";
import QMMultiselect from "./QMMultiselect";
import moment from "moment";
import { debounce } from "@material-ui/core";
import Swal from "sweetalert2";
import { DecryptED } from "../../DecryptJS/Decrypt";

export default function AddNewQuiz() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Quiz />
    </div>
  );
}

function Quiz() {
  const history = useHistory();
  const { sid, uid } = useParams();
  const hArray = history.location.state;

  const [classes, setclasses] = useState([]);
  const [div, setdiv] = useState([]);
  const [divnm, setdivnm] = useState([]);
  const [classSelected, setclassSelected] = useState([]);
  const [divSelected, setdivSelected] = useState([]);
  const [attempts, setattempts] = useState("");
  const [duration, setduration] = useState("");

  useEffect(() => {
    axios
      .post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
        fun_name: "GetClassDiv",
        sid: sid,
        u_id: uid,
      })
      .then((res) => {
        const divData = res.data.div || [];
        const classNames = divData.map((c) => c.class_name).filter(Boolean);
        setclasses([...new Set(classNames)]);

        const updatedDiv = divData.map((item) => ({
          ...item,
          div_name: item.div_name.trim().replace(/\s+/g, " "),
        }));

        setdiv(updatedDiv);
        setdivnm(updatedDiv);

        if (hArray && hArray.actiontodo !== "addquiz") {
          setclassSelected(hArray.class.split(","));
          setdivSelected(hArray.division.split(","));
          setattempts(hArray.attempts);
          setduration(hArray.duration);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (!classSelected.length) {
      setdivnm(div);
    } else {
      setdivnm(div.filter((d) => classSelected.includes(d.class_name)));
    }
  }, [classSelected, div]);

  if (!hArray) {
    return <Redirect to={`/quizapp/${sid}/${uid}`} />;
  }

  sessionStorage.setItem("lpath", history.location.pathname);

  const createQuiz = async () => {
    const classnmid = [];
    const divnmid = [];

    div.forEach((i) => {
      if (divSelected.includes(i.div_name)) {
        if (!divnmid.includes(i.divid)) divnmid.push(i.divid);
        if (!classnmid.includes(i.class)) classnmid.push(i.class);
      }
    });

    let formData = Array.from(document.getElementsByTagName("form")[0]).reduce(
      (a, i) => ({ ...a, [i.name || "invalidMS"]: i.value }),
      {}
    );
    delete formData.invalidMS;

    if (!formData.quizName)
      return Swal.fire("Warning", "Please enter quiz name", "error");
    if (!formData.duration)
      return Swal.fire("Warning", "Please enter duration", "error");
    if (!formData.class || formData.class === "Choose Class")
      return Swal.fire("Warning", "Please choose class", "error");
    if (!formData.division || formData.division === "Choose Division")
      return Swal.fire("Warning", "Please choose division", "error");
    if (!formData.publishDate)
      return Swal.fire("Warning", "Please choose publish date", "error");
    if (!formData.publishTime)
      return Swal.fire("Warning", "Please choose publish time", "error");
    if (!formData.attempts)
      return Swal.fire("Warning", "Please enter no of attempts", "error");

    try {
      await axios.post(
        "https://topschool.prisms.in/rest/index.php/user_list.json?",
        {
          fun_name: "Quizapp_Notif",
          sid,
          userid: uid,
          quizid: formData.id,
          classid: classnmid.join(","),
          divid: divnmid.join(","),
          action: `${formData.quizName}${
            formData.quizName.toLowerCase().includes("quiz") ? "" : " quiz"
          } is ${
            hArray.actiontodo === "addquiz"
              ? "published on " +
                moment(
                  formData.publishDate + " " + formData.publishTime,
                  "YYYY-MM-DD HH:mm:ss"
                ).format("LLLL")
              : "updated"
          }`,
        }
      );

      await axios.post(
        "https://topschool.prisms.in/rest/index.php/user_list.json?",
        {
          fun_name:
            hArray.actiontodo === "addquiz"
              ? "Quizapp_AddQuiz"
              : "Quizapp_UpdateQuiz",
          sid,
          userid: uid,
          ...formData,
        }
      );

      history.push(
        hArray.actiontodo === "addquiz"
          ? `/quizapp/createquestion/${sid}/${uid}`
          : `/quizapp/editquiz/quizUpdated/${sid}/${uid}`,
        hArray.actiontodo === "addquiz"
          ? {
              ...formData,
              actiontodo: "addquestion",
              nmark: formData.negativeMarking,
            }
          : { ...formData, actiontodo: "updatequiz" }
      );
    } catch (e) {
      console.error(e);
    }
  };

  function divcheckingfun(selectedDivs, selectedClasses) {
    if (!Array.isArray(selectedDivs)) selectedDivs = [selectedDivs];
    if (!Array.isArray(selectedClasses)) selectedClasses = [selectedClasses];

    const finalDivs = div
      .filter((d) => selectedClasses.includes(d.class_name))
      .map((d) => d.div_name);

    const newDivSelected = selectedDivs.filter((d) => finalDivs.includes(d));

    setclassSelected(selectedClasses);
    setdivSelected(newDivSelected);
  }

  return (
    <div className="quiz-container">
      <div className="quiz-head">
        <div className="quiz-head-title">{hArray.quizName}</div>
        <Navbar
          home={{ isHome: true, home: `${sessionStorage.tora}` }}
          back
          refresh={false}
        />
      </div>
      <hr className="hr-line" />

      <div className="quiz-list-items">
        <div className="quiz-form">
          <form id="form" autoComplete="off">
            <input
              type="number"
              style={{ display: "none" }}
              name="id"
              defaultValue={hArray.id}
            />

            <div className="form-div">
              <label>Quiz Name</label>
              <input
                type="text"
                placeholder="Enter Quiz Name"
                name="quizName"
                defaultValue={hArray.actiontodo === "addquiz" ? "" : hArray.quizName}
              />
            </div>

            <div className="form-div">
              <label>Duration</label>
              <input
                type="text"
                placeholder="Enter Duration in mins or 0 for unlimited"
                name="duration"
                value={duration}
                onChange={(e) => setduration(e.target.value.replace(/\D/g, ""))}
              />
            </div>

            <div className="form-div">
              <label>Class</label>
              <QMMultiselect
                data={classes}
                initialValues={classSelected}
                selected={(params) => divcheckingfun(divSelected, params)}
                name="class"
                placeholder="Choose Class"
              />
            </div>

            <div className="form-div">
              <label>Division</label>
              <QMMultiselect
                data={divnm}
                initialValues={divSelected}
                value="div_name"
                label="div_name"
                selected={(params) => divcheckingfun(params, classSelected)}
                name="division"
                placeholder="Choose Division"
              />
            </div>

            <div className="form-div">
              <label>Negative Marking</label>
              <select
                name="negativeMarking"
                defaultValue={hArray.actiontodo === "addquiz" ? "" : hArray.negativeMarking}
              >
                <option value="no">No</option>
                <option value="yes">Yes</option>
              </select>
            </div>

            <div className="form-div">
              <label>Question Order</label>
              <select
                name="questionOrder"
                defaultValue={hArray.actiontodo === "addquiz" ? "" : hArray.questionOrder}
              >
                <option value="sequential">Sequential</option>
                <option value="randomized">Randomized</option>
              </select>
            </div>

            <div className="form-div" style={{ display: "none" }}>
              <label>Publish Status</label>
              <select
                name="quizStatus"
                defaultValue={hArray.actiontodo === "addquiz" ? "" : hArray.quizStatus}
              >
                <option value={0}>Draft</option>
                <option value={1}>Public</option>
              </select>
            </div>

            <div className="form-div">
              <label>No of Attempts</label>
              <span style={{ marginTop: "0px", fontSize: "13px", color: "gray" }}>
                Note: Enter 0 for unlimited attempts
              </span>
              <input
                name="attempts"
                type="text"
                placeholder="Enter any number or 0 for unlimited"
                onChange={(e) => setattempts(e.target.value.replace(/\D/g, ""))}
                value={attempts}
              />
            </div>

            <div className="form-div">
              <label>Review</label>
              <select
                name="review"
                defaultValue={hArray.actiontodo === "addquiz" ? "" : hArray.review}
              >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>

            <div className="form-div">
              <label>Publish Date</label>
              <input
                type="date"
                name="publishDate"
                defaultValue={hArray.actiontodo === "addquiz" ? new Date().toISOString().slice(0, 10) : hArray.publishDate}
              />
            </div>

            <div className="form-div">
              <label>Publish Time</label>
              <input
                type="time"
                name="publishTime"
                defaultValue={hArray.actiontodo === "addquiz" ? new Date().toTimeString().slice(0, 5) : hArray.publishTime}
              />
            </div>
          </form>
        </div>
      </div>

      <div className="button-div">
        <button onClick={debounce(createQuiz, 500)} className="create-button">
          {hArray.actiontodo === "addquiz" ? "Create Quiz" : "Update Quiz"}
        </button>
      </div>
    </div>
  );
}
